import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class DcsDiagnosticsService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  save_DCS_Diagnostics(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    if (!data?.rowData) return of({ callSuccess: '0', errorMessage: 'Row data is required.' });
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonSetting: JSON.stringify(data.rowData),
      jsonObj: JSON.stringify(data.rowData),
      process_name: 'Save_DCS_DIAGNOSTICS'
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=9q1a26`,
      params,
      globalService,
      filterParams
    );
  }
}
